// developed by Param Partap Singh
import React from 'react'
import Nav from '../Utils/Nav'
import Footer from '../Utils/Footer'
import banner from '../Assets/background2.JPG'

export default function Application() {
  return (
    <>
    <Nav/>
    <div className='main-container'>
        <div className="banner">
            <img className="background" src={banner} alt="" />
            <h1 className="main-heading-title">Applications</h1>
        </div>
       

        <div className="box-containt">
            <div className="box-n">
                <h2>Moodle (medh Servers)</h2>
                <ul>
                    <li>Moodle is a learning management system (LMS) which is used for hosting the online classes/Quizzes. Access the moodle servers by follow moodle instruction page by below link.</li>
                     <a href="https://www.iitrpr.ac.in/moodle/" className='btn-n' target='_blank'><button className='btn-p'>Click Here</button></a>
                </ul>    
            </div>
            <div className="box-n">
                <h2>AIMS</h2>
                <ul>
                    <li>Academic Informaion Management System (AIMS) is a portal used for managing students academics. Instructor can create/offer courses,submit grades etc. Students can register in the course,check their academics,submit fees details.</li>
                    <div className='btn-div'>
                       <a href="https://www.iitrpr.ac.in/aims/" className='btn-n' target='_blank'><button className='btn-p'>Click Here</button></a>
                    </div>
                </ul>
            </div>
            <div className="box-n">
                <h2>Meeting Room Booking</h2>
                <ul>
                    <li>Central Booking Sysytem (CBS) is booking system to book lecture hall/ seminar hall of IIT Ropar. The IIT Ropar users can use their LDAP credentials to login into the CBS and book the classroom/seminars hall for both the campus Transit and Main Campus.</li>
                    <div className='btn-div'>
                       <a href="http://172.30.8.23/Web/" className='btn-n' target='_blank'><button className='btn-p'>Click Here</button></a>
                    </div>
                </ul>
            </div>
            <div className="box-n">
                <h2>LDAP Password Reset</h2>
                <ul>
                    <li>LDAP feature let you to authenticate various institute applications like Medh, CBS etc. using centralize authentication system. You can also change/reset your password from anywhere using below link.</li>
                    <div className='btn-div'>
                        
                       <a href="https://cas.iitrpr.ac.in/" className='btn-n'  target='_blank'><button className='btn-p'>Click Here</button></a>
                       
                    </div>
                </ul>
            </div>
            {/* <div className="box-n">
                <h2>Dspace</h2>
                <ul>
                    <li>DSpace is an institutional Repository of IIT Ropar. It preserves the research publications and Ph.D. Theses. It is easy and open access to all type of digital content.</li>
                    <div className='btn-div'>
                       <a href="http://dspace.iitrpr.ac.in:8080/xmlui/" className='btn-n' target='_blank'><button className='btn-p'>Click Here</button></a>
                    </div>
                </ul>
            </div> */}
            
            
            
        </div>


      
    </div>
    <Footer/>
    </>
  )
}
